let screenW = $(window).width()
let screenH = $(window).height()

function breakpoint(breakpoint)
{
  let breakpoints = {
    'xs': 0,
    'sm': 576,
    'md': 768,
    'lg': 992,
    'xl': 1024,
    'xxl': 1900,
    'screenW': screenW,
    'screenH': screenH,
  }
  return breakpoints[breakpoint]
}

function breakpointUp(value)
{
  return breakpoint('screenW') >= breakpoint(value)
}

function breakpointDown(value)
{
  return breakpoint('screenW') < breakpoint(value)
}

function screenSizeCoefficient()
{
  let coefficient = 1
  if ($(window).width() > 1440) {
    coefficient = $(window).width() /  1440
  }

  coefficient = coefficient < 0.7 ? 0.7 : coefficient

  return coefficient
}

export { breakpoint, screenSizeCoefficient, breakpointUp, breakpointDown }
